import { render, staticRenderFns } from "./DataRow.vue?vue&type=template&id=12329762&scoped=true&"
import script from "./DataRow.vue?vue&type=script&lang=ts&"
export * from "./DataRow.vue?vue&type=script&lang=ts&"
import style0 from "./DataRow.vue?vue&type=style&index=0&id=12329762&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12329762",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
